import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { BankAccount, BankAccountCreate, BankAccountFilter } from '../data/bankAccount';

export function createBankAccountService(client: AxiosInstance) {
  return createCrudService<BankAccount, BankAccountCreate, BankAccountFilter>(
    client,
    '/accounting/BankAccount',
    'id',
  );
}

export type BankAccountService = CrudService<BankAccount, BankAccountCreate, BankAccountFilter>;
